import React, { useState } from 'react';
import { GET_QUOTES_INFORMATION_getQuotesInformation, GET_QUOTES_INFORMATION_getQuotesInformation_latestPeriod } from './graphql/__generated__/GET_QUOTES_INFORMATION';
import styled from 'styled-components';
import { LayoutContainer } from '../AccountInformationPage/AccountInformationPageStyles';
import { CardLayout } from '../../components/cardLayout/CardLayout';
import { formatDateAsString, formatDateObj } from '../../util/formatters';
import { ContinueButton, DataGroup, OuterBox, OuterBoxx, TextData, WithdrawButton } from '../../components/quotesInfo/QuotesInfoStyles';
import { Box } from 'grommet';
import { ChangeForm, WhiteBox } from '../../components/changePolicy/changePolicyStyles';
import { MainWrapper } from '../../components/footer/FooterStyles';
import { stat } from 'fs';
import { GET_POLICY_QUOTE_TABLE_INFO_account_items_overviewPoliciesAndQuotes } from '../../components/quotesInfo/graphql/GET_QUOTES_INFO';
import AlertModal from '../../components/gpaCancelPolicy/AlertModal';
import { CancelPolicyAccordionBody, CancelPolicyAccordionHead, CancelPolicyAccordionWrap, HeaderIcon, HeaderIconWrap, HeaderTitle, HeaderTitleWrap, MessageTextBox, QuoteOptionsHead, WarningIconSizing } from '../../components/gpaCancelPolicy/gpaCancelPolicyStyles';
import { CancelPolicyDisabled, ChevronRight, Edit, PolicyChange, Warning } from '../../icons';
import CancelPolicyIconSrc from '../../assets/images/CancelPolicy.svg';
import FileSRC from '../../assets/images/File.svg';

interface policyInfoProps {
    jobNumber: string | null;
    contactName: string | null;
    latestPeriod: GET_QUOTES_INFORMATION_getQuotesInformation_latestPeriod | null;
    createTime: string | null;
}

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  & > * > button:not(:first-child) {
    margin-left: 15px;
  }
`;
export const ButtonContainerQuote = styled.div`
  display: flex;
  flex-direction: row;
  & > * > button:not(:first-child) {
    margin-left: 15px;
  }
`;

export interface QuoteOperationsProps {
    jobNumber: string | null;
    latestPeriod: GET_QUOTES_INFORMATION_getQuotesInformation_latestPeriod | null;
    status: string | null;
    closeDate: string | null;
    policyIssued: boolean;
    redirectOnQuoteClickAction: Function;
    sourceSystemCode: string;
    withdrawClickHandler: Function;
    loader: boolean;
    setLoader: Function;
    buttonDisabled: boolean;
}

export default ({
    jobNumber,
    latestPeriod,
    status,
    closeDate,
    policyIssued,
    redirectOnQuoteClickAction,
    sourceSystemCode,
    loader,
    setLoader,
    withdrawClickHandler,
    buttonDisabled
}: QuoteOperationsProps) => {
    const [selectedQuote, setSelectedQuote] = useState<string | null>(null);
    const [selectedCode, setSelectedCode] = useState<string | null>(null);
    const [showQuoteAlert, setShowQuoteAlert] = useState<boolean>(false);
    const withDrawQuoteClickHandler = (quote: string, code: string) => {
        setShowQuoteAlert(true);
        setSelectedQuote(quote);
        setSelectedCode(code);
    };

    const handleWithdrawConfirm = async () => {
        if (!selectedQuote) return;
        try {
            setLoader(true);
            await withdrawClickHandler(selectedQuote, selectedCode);
        } finally {
            setLoader(false);
            setShowQuoteAlert(false);
            setSelectedQuote(null);
        }
    };

    const handleAlertClose = () => {
        setShowQuoteAlert(false);
        setSelectedQuote(null);
    };

    const canWithdraw = () => {
        if (!!status) {
            if ((status).toLowerCase() === 'withdrawn') {
                return false;
            }
            else if ((status).toLowerCase() !== 'bound' && !closeDate && !policyIssued) {
                return true;
            }
        }
        return false;
    };
    const canIssue = () => {
        if (!!status) {
            return ((status).toLowerCase() === 'bound' && !policyIssued);   //TODO: Confirm this. --  this is for issuance.
        }
        return false;
    };

    return (
        <>
            {
                showQuoteAlert && selectedQuote && (
                    <AlertModal
                        showError
                        errorHeader='Withdraw Quote'
                        fromQuotes
                        withdrawQuote={() => handleWithdrawConfirm()}
                        errorMessage={`Are you sure you want to withdraw quote: ${selectedQuote}`}
                        handleAlertClose={handleAlertClose}
                        loader={loader}
                        setLoader={setLoader}
                    />
                )
            }
            <CancelPolicyAccordionWrap>
                {canWithdraw() && (
                    <>

                        <QuoteOptionsHead
                            disabled={false}
                        >
                            <HeaderIconWrap>
                                <>
                                    <PolicyChange />
                                    {/* <HeaderIcon src={FileSRC} /> */}

                                </>
                            </HeaderIconWrap>
                            <HeaderTitleWrap>
                                <HeaderTitle>QUOTE OPERATIONS</HeaderTitle>
                            </HeaderTitleWrap>
                        </QuoteOptionsHead>
                        <CancelPolicyAccordionBody isOpen={true}>
                            <LayoutContainer >
                                <MainWrapper>
                                    <WhiteBox>
                                        <ChangeForm test-attr="change-policy-dropdown-frame">
                                            What action would you like to take on this quote?
                                                <ButtonContainer>
                                                    <div>
                                                        {canWithdraw() ? (
                                                            <ContinueButton
                                                                disabled={buttonDisabled}
                                                                type="button"
                                                                onClick={() => {
                                                                    redirectOnQuoteClickAction({
                                                                        variables: {
                                                                            quoteId: jobNumber,
                                                                            continueQuote: true,
                                                                            sourceSystem: sourceSystemCode
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                CONTINUE QUOTE
                                                            </ContinueButton>) : <></>}
                                                        {
                                                            canWithdraw() ?

                                                                (<WithdrawButton
                                                                    disabled={buttonDisabled}
                                                                    type="button"
                                                                    onClick={() => {
                                                                        jobNumber && sourceSystemCode && withDrawQuoteClickHandler(jobNumber, sourceSystemCode.toLowerCase() === 'commercial' ? 'GWCL' : 'GWPL');
                                                                    }}
                                                                >
                                                                    WITHDRAW QUOTE
                                                                </WithdrawButton>) : <></>
                                                        }

                                                    </div>
                                                </ButtonContainer>
                                        </ChangeForm>
                                    </WhiteBox>
                                </MainWrapper>
                            </LayoutContainer >
                        </CancelPolicyAccordionBody>
                    </>
                )}
            </CancelPolicyAccordionWrap>
            {/* </Box> */}
            {/* </CardLayout> */}
        </>
    );
};

